import { struct } from 'io-ts/Decoder';

import { Id as SubscriptionId } from '../../../../push/subscription/Id';

export const Param = struct({
	subscriptionId: SubscriptionId,
});
